<template>
  <section>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="160px"></qx-custom-form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '员工数量',
            value: 'staffNumber',
            type: 'input',
          },
          {
            label: '自有车数',
            value: 'vehicleNumber',
            type: 'input',
          },
          {
            label: '年营业额（万元）',
            value: 'annualTurnoverDouble',
            type: 'input',
          },
        ],
        rules: {
          staffNumber: [
            { required: true, message: '请输入员工数量', trigger: 'blur' },
          ],
          vehicleNumber: [
            { required: true, message: '请输入自有车数', trigger: 'blur' },
          ],
          annualTurnoverDouble: [
            { required: true, message: '请输入年营业额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      console.log(formData);
      return formData;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
